import store from '@/store'
import status from '@/services/constants/status'
import AppLog from '@/services/errors/app-logs'
import calloutBubbleMessanger from '@/services/calloutBubbleMessanger'
//TODO: Create mapper function instead of standalone functions.

export function sendMessageInWidget(data) {
    const {messageInfo: {text,label}} = data
    const message = {
        userMessage: {
            payload: text,
            label
        }
    }
    store.dispatch('sendMessage', message)
}

export function endSession(data) {
    const {messageInfo} = data
    store.dispatch('endChat', messageInfo)
}

export function openChatWidget(data) {
    const isFullScreen = data.isFullScreen === undefined ? store.state.widgetConfig.isDefaultFullScreen : data.isFullScreen
    store.dispatch('updateWidgetStatus', {status: status.OPEN, isFullScreen})
}

export function closeChatWidget(data) {
    store.dispatch('updateWidgetStatus', {status: status.CLOSE, isFullScreen: data.isFullScreen})
}

export function acceptTokenInWidget(data) {
    const {messageInfo} = data
    store.dispatch('updateTokenInWidget', messageInfo)
}

export function acceptVisitorInfo(data) {
    const {messageInfo} = data
    store.dispatch('updateWidgetVisitorInfo', messageInfo)
}

export function loginWidget(data) {
    const {messageInfo} = data
    store.dispatch('setUserLoggedIn', messageInfo)
}

export function logoutWidget() {
    store.dispatch('logoutWidget')
}




export function showCalloutBubble(data) {
    const {messageInfo} = data
    store.dispatch('showCalloutBubbleFromPubsub', messageInfo)
}


export function toggleCalloutBuble(data) {
    const {messageInfo} = data
    calloutBubbleMessanger.sendMessage({ 
      eventType: 'TOGGLE_CALLOUT_BUBBLE',
      data: { show: messageInfo }
    })
}

export function changeLocale(data) {
    const locale = data?.messageInfo
    store.dispatch('updateLocale', locale)
}

export async function backToBotAction() {
    store.dispatch('backToBotAction')
}

export  function showExternalHeaderText(data) {
    new AppLog({ 
        message: `Show External Header Text function called with argument: ${JSON.stringify(data)}`,
        logLevel: 'info',
        name: 'showExternalHeaderText',
        service: 'External Event'
    })
    const {messageInfo} = data
    store.dispatch('showExternalHeaderText', messageInfo)
}

export function hideHeaderMenuButtons() {
    new AppLog({ 
        message: 'Hide Header Menu Buttons function called',
        logLevel: 'info',
        name: 'hideHeaderMenuButtons',
        service: 'External Event'
    })
    store.dispatch('showHeaderMenuButtons', false)
}

export  function acceptPromptTestDetails(data) {
    new AppLog({ 
        message: `Accept Prompt Test Details function called with argument: ${JSON.stringify(data)}`,
        logLevel: 'info',
        name: 'acceptPromptTestDetails',
        service: 'External Event'
    })
    const {messageInfo} = data
    store.dispatch('updatePromptTestDetails', messageInfo)
    store.dispatch('setIsCalloutBubbleEnabled' , false)
}

export async function removeWidget() {
    store.dispatch('removeChatWidget')
}

export function setCalloutBubbleConfig ({ messageInfo }) {
    store.dispatch('setCalloutBubbleConfig', messageInfo)
}

export function sendLogToDatadog({ messageInfo }) {
    new AppLog({
        name: messageInfo.name, 
        message: messageInfo.message, 
        logLevel: messageInfo.logLevel, 
        service: messageInfo.service
    })
}

export function hideSupportIcon() {
    store.dispatch('updateSupportIconState', { visible: false })
}

export async function oauthLoginWidget(data) {
    store.dispatch('oauthLoginWidget', data)
}
export function showVisitorInfoButton() {
    new AppLog({ 
        message: 'Show Visitor Info Button function called',
        logLevel: 'info',
        name: 'showVisitorInfoButton',
        service: 'External Event'
    })
    store.dispatch('showVisitorInfoButton', true)
}
export function responseAnalyzerShowVisitorInfoForm() {
    new AppLog({ 
        message: 'Show Visitor Info Form function called',
        logLevel: 'info',
        name: 'responseAnalyzerShowVisitorInfoForm',
        service: 'External Event'
    })
    store.dispatch('showVisitorInfoForm', true)
}

export function changeBotConfig ({messageInfo}) {
    store.dispatch('updateBotConfig', messageInfo)
}
